/* eslint-disable */
import uiI18n from "../../../i18n";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { DHD_PLAN_NAME } from "../../DhdCurrentPlanBanner";

const getV3SheetConfig = (store, sheetConfigKey) => {
  if (sheetConfigKey === "sheetabndn") {
    const config = Array.isArray(store?.sheetabndn)
      ? store.sheetabndn[0]
      : null;
    return {
      googleSheetId: config?.googleSheetId || "",
      googleSheetName: config?.googleSheetName || "",
      googleSheetColumns: config?.googleSheetColumns || [],
    };
  }

  return {
    googleSheetId: store?.googleSheetId || "",
    googleSheetName: store?.googleSheetName || "",
    googleSheetColumns: store?.googleSheetColumns || [],
  };
};

/* ✅ V3 */
const handleUpdateSheetV3 = async (
  selectedProducts,
  store,
  sheetConfigKey = "default",
  onSuccess = null, // ✅ زيد هذا
) => {
  const products = Array.isArray(selectedProducts)
    ? selectedProducts
    : Array.from(selectedProducts || []);

  const sheetConfig = getV3SheetConfig(store, sheetConfigKey);

  if (!products || products.length === 0) {
    Swal.fire({
      icon: "warning",
      title: uiI18n.t("cashBack.states.noPromotions.emptyProduct"),
      text: uiI18n.t("ui.selectProductToSend"),
      confirmButtonText: uiI18n.t("common.ok"),
    });
    return;
  }

  const invalidProduct = products.find((product) => product.isValid === true);
  if (invalidProduct) {
    Swal.fire({
      icon: "warning",
      title: uiI18n.t("ui.orderInactive"),
      text: uiI18n.t("ui.activateOrderFirst"),
      confirmButtonText: uiI18n.t("common.ok"),
    });
    return;
  }

  const confirmResult = await Swal.fire({
    title: uiI18n.t("cashBack.swal.deleteConfirm.title"),
    text: uiI18n.t("ui.sendOrdersToSheetV3"),
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#0EA5E9",
    cancelButtonColor: "#d33",
    confirmButtonText: uiI18n.t("ui.yesSend"),
    cancelButtonText: uiI18n.t("annule"),
  });

  if (!confirmResult.isConfirmed) return;

  try {
    const requests = products.map(async (product) => {
      const data = {
        name: product.name,
        orderId: product.id,
        product: product.nameproduct || "",
        phone: product.phone,
        state: product.state,
        commune: product.commune,
        address: product.address,
        qty: product.qty,
        note: product.note,
        price: product.products[0]?.price || 0,
        deleveryPrice: product.deleveryPrice || 0,
        deleveryStatus: product.deleveryStatus,
        total: product.total,
        options: product.options,
        deliveryType: product.stopdeskDelivery || "",
        products: product.products || [],
        googleSheetId: sheetConfig.googleSheetId,
        googleSheetName: sheetConfig.googleSheetName,
        googleSheetColumns: sheetConfig.googleSheetColumns,
      };

      const res = await fetch(
        "https://backend-sheet.foorweb.store/api/googleSheetV3",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        },
      );

      const result = await res.json();

      if (!res.ok || result.status !== "success") {
        throw new Error(
          `فشل إرسال الطلب: ${product.name} - ${
            result.error || "خطأ غير معروف"
          }`,
        );
      }

      return result;
    });

    await Promise.all(requests);

    if (typeof onSuccess === "function") {
      onSuccess(products.map((p) => p.id));
    }
    Swal.fire({
      icon: "success",
      title: uiI18n.t("ui.successful"),
      text: uiI18n.t("ui.sheetOrdersSent"),
      confirmButtonColor: "#0EA5E9",
    });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: uiI18n.t("ui.sendingFailed"),
      text: error.message,
      confirmButtonColor: "#0EA5E9",
    });
  }
};

/* ✅ V1 + V2 كما هما */
const handleUpdateSheet = async (selectedProducts, version = "v1", store) => {
  const products = Array.isArray(selectedProducts)
    ? selectedProducts
    : Array.from(selectedProducts || []);

  if (!products || products.length === 0) {
    Swal.fire({
      icon: "warning",
      title: uiI18n.t("cashBack.states.noPromotions.emptyProduct"),
      text: uiI18n.t("ui.selectProductToSend"),
      confirmButtonText: uiI18n.t("common.ok"),
    });
    return;
  }

  const invalidProduct = products.find((product) => product.isValid === true);
  if (invalidProduct) {
    Swal.fire({
      icon: "warning",
      title: uiI18n.t("ui.orderInactive"),
      text: uiI18n.t("ui.activateOrderFirst"),
      confirmButtonText: uiI18n.t("common.ok"),
    });
    return;
  }

  const versionText = version === "v1" ? "الإصدار الأول" : "الإصدار الثاني";
  const confirmResult = await Swal.fire({
    title: uiI18n.t("cashBack.swal.deleteConfirm.title"),
    text: uiI18n.t("ui.sendOrdersToSheet", { value0: versionText }),
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#9e68ba",
    cancelButtonColor: "#d33",
    confirmButtonText: uiI18n.t("ui.yesSend"),
    cancelButtonText: uiI18n.t("annule"),
  });

  if (!confirmResult.isConfirmed) return;

  try {
    const requests = products.map(async (product) => {
      const data = {
        name: product.name,
        orderId: product.id,
        product: product.nameproduct || "",
        phone: product.phone,
        state: product.state,
        commune: product.commune,
        address: product.address,
        qty: product.qty,
        note: product.note,
        price: product.products[0].price,
        deleveryPrice: product.deleveryPrice || 0,
        deleveryStatus: product.deleveryStatus,
        total: product.total,
        options: product.options,
        deliveryType: product.deliveryType || "",
        googleSheet: version === "v1" ? store?.googleShit : store?.googleSheet,
      };

      const endpoint =
        version === "v1"
          ? "https://backend.foorweb.store/api/submitGoogleSheet"
          : "https://backend.foorweb.shop/api/googleSheet";

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok || result.status !== "success") {
        throw new Error(
          `فشل إرسال الطلب: ${product.name} - ${
            result.error || "خطأ غير معروف"
          }`,
        );
      }

      return result;
    });

    await Promise.all(requests);

    Swal.fire({
      icon: "success",
      title: uiI18n.t("ui.successful"),
      text: uiI18n.t("ui.ordersSentToSheet", { value0: versionText }),
      confirmButtonColor: "#9e68ba",
      confirmButtonText: uiI18n.t("systemDhd.step1.ratings.excellent"),
    });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: uiI18n.t("ui.sendingFailed"),
      text: error.message,
      confirmButtonText: uiI18n.t("annule"),
    });
  }
};

const GoogleSheetButtons = ({
  selectedProducts,
  t,
  store,
  showOnlyV3 = false,
  sheetConfigKey = "default",
  buttonName = "googleSheet",
  onSuccess = null,
}) => {
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  // dhd partnership users: google sheet export is not available
  if (isDhdUser) return null;
  console.log(selectedProducts);
  const hasGoogleShitV1 = store?.googleShit && store.googleShit.trim() !== "";
  const hasGoogleSheetV2 =
    store?.googleSheet && store.googleSheet.trim() !== "";
  const sheetConfig = getV3SheetConfig(store, sheetConfigKey);
  const hasGoogleSheetV3 =
    sheetConfig.googleSheetId &&
    sheetConfig.googleSheetColumns?.length > 0 &&
    sheetConfig.googleSheetName;

  if (!hasGoogleShitV1 && !hasGoogleSheetV2 && !hasGoogleSheetV3) return null;

  return (
    <div className="flex gap-2">
      {/* ❌ نغلق V1 إذا showOnlyV3 */}
      {!showOnlyV3 && hasGoogleShitV1 && (
        <button
          disabled={selectedProducts.length < 1}
          onClick={() => handleUpdateSheet(selectedProducts, "v1", store)}
          className={`p-2 bg-white border dark:!bg-[#141414] ${
            selectedProducts.length < 1
              ? "border-gray-200 opacity-50 cursor-not-allowed"
              : "border-purple-200 hover:bg-purple-50"
          } rounded-lg flex items-center gap-2`}
        >
          <span
            className={`${
              selectedProducts.length < 1 ? "text-gray-400" : "text-[#9e68ba]"
            }`}
          >
            {t("orders.datatable_templating_demo.googleSheet")} V1
          </span>
        </button>
      )}

      {/* ❌ نغلق V2 إذا showOnlyV3 */}
      {!showOnlyV3 && hasGoogleSheetV2 && (
        <button
          disabled={selectedProducts.length < 1}
          onClick={() => handleUpdateSheet(selectedProducts, "v2", store)}
          className={`p-2 bg-white border dark:!bg-[#141414] ${
            selectedProducts.length < 1
              ? "border-gray-200 opacity-50 cursor-not-allowed"
              : "border-green-200 hover:bg-green-50"
          } rounded-lg flex items-center gap-2`}
        >
          <span
            className={`${
              selectedProducts.length < 1 ? "text-gray-400" : "text-[#22c55e]"
            }`}
          >
            {t("orders.datatable_templating_demo.googleSheet")} V2
          </span>
        </button>
      )}

      {/* ✔️ زر V3 يظهر دائمًا */}
      {hasGoogleSheetV3 && (
        <button
          disabled={selectedProducts.length < 1}
          onClick={() =>
            handleUpdateSheetV3(
              selectedProducts,
              store,
              sheetConfigKey,
              onSuccess,
            )
          }
          className={`p-2 bg-white border dark:!bg-[#141414] ${
            selectedProducts.length < 1
              ? "border-gray-200 opacity-50 cursor-not-allowed"
              : "border-blue-300 hover:bg-blue-50"
          } rounded-lg flex items-center gap-2`}
        >
          <span
            className={`${
              selectedProducts.length < 1 ? "text-gray-400" : "text-blue-500"
            }`}
          >
            {buttonName}
          </span>
        </button>
      )}
    </div>
  );
};

/* ✅ Export */
export {
  handleUpdateSheet,
  handleUpdateSheetV3,
  GoogleSheetButtons,
  handleUpdateSheet as handleUpdateSheetV1,
  handleUpdateSheet as handleUpdateSheetV2,
};

export default GoogleSheetButtons;
